import React from "react";

import { InfoSmIcon as InfoSm, Typography } from "@packages/ds";
import { useIntl } from "react-intl";
import styled from "styled-components";

import { IconControl } from "ds/Button";
import Dialog from "ds/Dialog";
import * as O from "src/organization/pages/billing/components/Overview/BillingOverview.styles";

import * as S from "../Panel/Panel.style";

const Meter = ({
  min,
  max,
  value
}: {
  min: number;
  max: number;
  value: number;
}) => {
  const Outer = styled.div`
    background-color: var(--theme-neutral-100);
    border-radius: 4px;
    width: 100%;
    height: 8px;
    overflow: hidden;
    margin-top: 8px;
    margin-bottom: 8px;
  `;

  const Inner = styled.div<{ width: number }>`
    background-color: var(--theme-primary-600);
    border-radius: 4px;
    width: ${props => `${props.width}%`};
    height: 100%;
  `;

  if (max === min) return null;

  return (
    <Outer>
      <Inner width={((value - min) / (max - min)) * 100}></Inner>
    </Outer>
  );
};

interface Props {
  currentValue?: number;
  currentFormatted: string;
  projectedValue: number;
  projectedFormatted: string;
}
const CurrentSpendDetails = ({
  currentValue,
  currentFormatted,
  projectedValue,
  projectedFormatted
}: Props) => {
  const intl = useIntl();

  return (
    <O.PanelWrapper>
      <O.Stack>
        <S.PanelRow minHeight="32px">
          <O.SpacedRow space={16}>
            <Typography.BodyText weight="bold">
              {intl.formatMessage({
                id: "organization.billing.current_spend_this_month"
              })}
            </Typography.BodyText>
          </O.SpacedRow>
        </S.PanelRow>
        <S.PanelRow>
          <O.Stack space={8}>
            <O.SpacedRow>
              <Typography.Title tag="h2">{currentFormatted}</Typography.Title>
              <Typography.BodyText
                $color="slate"
                size="extraSmall"
                weight="semiBold"
              >
                / {projectedFormatted} projected total
              </Typography.BodyText>
              <Dialog
                analyticId="organization.billing.estimate.description.current"
                title={intl.formatMessage({
                  id: "organization.billing.projected_total.title.current"
                })}
                description={intl.formatMessage({
                  id: "organization.billing.projected_total.description.current"
                })}
                trigger={
                  <IconControl aria-label="info-trigger">
                    <InfoSm />
                  </IconControl>
                }
              />
            </O.SpacedRow>
            <Meter min={0} max={projectedValue} value={currentValue ?? 0} />
          </O.Stack>
        </S.PanelRow>
      </O.Stack>
    </O.PanelWrapper>
  );
};

export default CurrentSpendDetails;
